'use strict';

if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behavior.
    require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions.js');
}

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// More polyfill for bo ui...
!Object.entries && require('core-js/fn/object/entries');
!Array.prototype.includes && require('core-js/fn/array/includes');


//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 402
// module chunks = 5